import React from 'react';
import Banner from '../Components/Banner';
import { useLanguage } from '../context/LanguageContext';

function Blog() {
  const { t } = useLanguage();

  return (
    <div className="page-wrap">
      <Banner
        pageName={t.pages.blog}
        pageLink="/blog"
        subtitle={t.blog.subtitle}
        eyebrow="Innovative Horizons"
        image="https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1800&q=80"
      />

      <section className="section">
        <div className="container">
          <div className="section-title center">
            <div className="eyebrow">Editorial</div>
            <h2>{t.blog.title}</h2>
            <p>{t.blog.intro}</p>
          </div>

          <div className="grid-3">
            {t.blog.posts.map((post) => (
              <article className="article-card" key={post.title}>
                <div className="article-card-top">
                  <div className="service-icon">
                    <i className="fas fa-feather-alt" />
                  </div>
                  <span className="article-badge">Insight</span>
                </div>

                <h3>{post.title}</h3>
                <p>{post.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Blog;